import { useAccountLayoutStyle } from './account-layout.styles'

export const useAccountLayout = () => {
  const classes = useAccountLayoutStyle()

  return {
    classes,
  }
}
